import axiosInstance, { axiosBasicInstance } from '../config/axios';
import type { APIResp } from '../types/APIService';
import type { User, UserPut } from '../types/User';

export async function getCurrentUser() {
  try {
    const res = await axiosBasicInstance.get<APIResp<User>>('/profile');
    return res.data.data;
  }
  catch {
    return null;
  }
}

export async function updateUser(body: UserPut) {
  try {
    const res = await axiosInstance.put<APIResp<User>>(`/users/${body.id}`, body);
    return res.data.data;
  }
  catch {
    return null;
  }
}

export async function updateUserReadNews(userId: number, newsIds: number[]) {
  try {
    await axiosInstance.patch<APIResp<User>>(`/users/${userId}/news`, newsIds);
    return true
  }
  catch {
    return false;
  }
}


export async function getAllUsers(): Promise<User[]> {
  try {
    const res = await axiosInstance.get<APIResp<User[]>>('/users');
    return res.data.data;
  }
  catch {
    return [];
  }
}


export async function deleteUser(userId:number): Promise<boolean> {
  try {
    await axiosInstance.delete<APIResp<null>>(`/users/${userId}`);
    return true;
  }
  catch {
    return false;
  }
}
